import { BrowserRouter, Routes, Route } from 'react-router-dom';

import App from '../App';
import MainPage from '../pages/MainPage';
import Portfolio from '../pages/PortfolioPage';
import PortfolioDetail from '../pages/PortfolioDetail';
import { ErrorPage, FAQPage, StudioPage } from 'pages';

// import 'api/firebase';
const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path='/*' element={<ErrorPage />} />
          <Route path='/' element={<MainPage />} />
          <Route path='/Studio' element={<StudioPage />} />
          <Route path='/portfolio' element={<Portfolio />} />
          <Route path='/portfolio/:category' element={<PortfolioDetail />} />
          <Route path='/FAQ' element={<FAQPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
